import { FunnelChart } from "react-funnel-pipeline";
import "react-funnel-pipeline/dist/index.css";
import { KPISlice } from "../service/DataProcessorService";

interface ConversionFunnelProps {
  kpis: KPISlice;
  loading?: boolean;
}

export function ConversionFunnel({ kpis }: ConversionFunnelProps) {

  const funnelData = [
    {
      name: "Total de Leads",
      value: Number(Object.values(kpis.leadsSixtyDaysAgo).reduce((sum, v) => sum + Number(v), 0)).toLocaleString("pt-BR") ?? 0
    },
    {
      name: "Novos Leads",
      value: Number(kpis.leadsSixtyDaysAgo?.new_lead).toLocaleString("pt-BR") ?? 0
    },
    {
      name: "Em negociação",
      value: Number(kpis.leadsSixtyDaysAgo?.incomplete).toLocaleString("pt-BR") ?? 0
    },
    {
      name: "Em Tratativa",
      value: Number(kpis.leadsCountByStatus?.under_negotiation).toLocaleString("pt-BR") ?? 0
    },
    {
      name: "Validados",
      value: Number(kpis.leadsSixtyDaysAgo?.ready_to_rent).toLocaleString("pt-BR") ?? 0
    },
    {
      name: "Convertidos",
      value: Number(kpis.convertedSixtyAge).toLocaleString("pt-BR") ?? 0
    },
  ];

  return (
    <div className="w-full min-w-0 mt-8 lg:mt-0">
      <h3 className="text-lg font-semibold text-gray-500 mb-4">Funil de Conversão</h3>
      <div className="min-h-[300px] sm:min-h-[380px] lg:min-h-[460px]">
        <FunnelChart
          data={funnelData}
          showValues
          showNames
          pallette={["#1e1e1e", "#f59e42", "#ef4444", "#34d399", "#3b82f6"]}
          showRunningTotal={false}
          getRowNameStyle={() => ({ fontSize: "20px", fontWeight: "bold" })}
          getRowValueStyle={() => ({ fontSize: "20px", fontWeight: "bold" })}
          getToolTip={(row) => `${row.name}\n${Number(row.value).toLocaleString("pt-BR")}`}
        />
      </div>
    </div>
  );
}
